import React from "react";

/**
 * Central place to control which words get the "glitch" treatment across the site.
 * Add/remove words here and it will affect About/Portfolio/Contact/Home (where applied).
 */
export const GLITCH_WORDS = [
  "Data",
  "Software",
  "Српски",
  "Senidah",
  "Frostpunk",
  "Database",
  "citizen",
  "u",
  "Returnal",
  "Warzone",
  "Tame",
  "Games",
  "Analyzed"
];

function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Wraps configured words in <span className="glitch" data-text="...">...</span>
 * so the CSS glitch effect can render consistently across pages.
 */
export function applyGlitchEffect(text, words = GLITCH_WORDS) {
  const safeWords = (words || []).filter(Boolean);
  if (!safeWords.length) return text;

  const escaped = safeWords.map(escapeRegExp);
  const regex = new RegExp(`(${escaped.join("|")})`, "gi");

  return String(text)
    .split(regex)
    .map((part, index) =>
      safeWords.some((w) => w.toLowerCase() === String(part).toLowerCase()) ? (
        <span key={index} className="glitch" data-text={part}>
          {part}
        </span>
      ) : (
        part
      )
    );
}
